export default {
  tcVariables: function tcVariables(state) {
    return state.tcVariables;
  }
};